import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Container } from "components/generic/layout";
import { Overlay } from "components/common/candidate";
import { BoxSpinner, Status } from "components/generic/kit";
import { replaceParams } from "core/utils";
import { colors } from "core/stylesheet";
import { candidate } from "routes/paths";
import * as model from "modules/booking/model";
import * as R from "ramda";

const head = ["Insider", "Company", "Date", "Duration", "Status", "Price"];

const StyledLink = styled(Link)`
  color: ${colors.brand};
`;

const Td = styled.td.attrs({
  className: ({ className = "" }) => "bb b--black-10 pv2 f7 " + className
})``;

export default ({ calls, isLoading }) => (
  <Overlay>
    <Container>
      {isLoading ? (
        <BoxSpinner />
      ) : (
        <div>
          <div className="pv5">
            <div className="fw6 mb3">Upcoming calls</div>
            <div className="bg-white pa3 br2 f6 overflow-auto">
              <table className="f6 w-100 center" cellSpacing="0">
                <thead>
                  <tr>
                    {head.map((item, i) => (
                      <th className="pb3 fw6 bb b--black-20 tl" key={i}>
                        {item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {calls.data && calls.data.length > 0 ? (
                    givenCalls(isUpComing, calls).map((item, i) => (
                      <tr key={i}>
                        <Td className="w5">
                          <StyledLink
                            className="fw6"
                            to={replaceParams(
                              candidate.candidateDashboardCall,
                              {
                                id: item.id
                              }
                            )}
                          >
                            {item.insider.name}
                          </StyledLink>
                        </Td>
                        <Td>{item.insider.company}</Td>
                        <Td>{model.formatTime(item.date)}</Td>
                        <Td>{item.duration} minutes</Td>
                        <Td>
                          <Status>{item.status}</Status>
                        </Td>
                        <Td>${item.price}</Td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="tc pt3">
                        You have no upcoming calls
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="pv5">
            <div className="fw6 mb3">Calls history</div>
            <div className="bg-white pa3 br2 f6 overflow-auto">
              <table className="f6 w-100 center" cellSpacing="0">
                <thead>
                  <tr>
                    {head.map((item, i) => (
                      <th className="pb3 fw6 bb b--black-20 tl" key={i}>
                        {item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {calls.data && calls.data.length > 0 ? (
                    givenCalls(isHistoryCall, calls).map((item, i) => (
                      <tr key={i}>
                        <Td className="w5">
                          <StyledLink
                            className="fw6"
                            to={replaceParams(
                              candidate.candidateDashboardCall,
                              {
                                id: item.id
                              }
                            )}
                          >
                            {item.insider.name}
                          </StyledLink>
                        </Td>
                        <Td>{item.insider.company}</Td>
                        <Td>{model.formatTime(item.date)}</Td>
                        <Td>{item.duration} minutes</Td>
                        <Td>
                          <Status>{item.status}</Status>
                        </Td>
                        <Td>${item.price}</Td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="tc pt3">
                        You have no calls history
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </Container>
  </Overlay>
);

const isUpComing = n => n.status === "Open" || n.status === "Confirmed";
const isHistoryCall = n =>
  n.status === "Settled" || n.status === "Closed" || n.status === "Canceled";
const givenCalls = (status, bookings) => {
  const sortBookings = R.sortWith([R.descend(R.prop("date"))]);
  return R.filter(status, sortBookings(bookings.data));
};



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/DashboardMain/View.js